import { render, staticRenderFns } from "./SuperadminEnums.vue?vue&type=template&id=650f6b46&scoped=true&"
import script from "./SuperadminEnums.vue?vue&type=script&lang=js&"
export * from "./SuperadminEnums.vue?vue&type=script&lang=js&"
import style0 from "./SuperadminEnums.vue?vue&type=style&index=0&id=650f6b46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650f6b46",
  null
  
)

export default component.exports